/**
 * 검색·SNS·메신저 봇 User-Agent 패턴.
 * Bing은 JS 렌더링 크롤러라 페이지 hydration 후 fetch까지 따라온다.
 * 봇 트래픽은 트래킹/피드백 등 사용자 행위성 API 호출 대상이 아니므로 사전 차단에 사용한다.
 */
export const BOT_USER_AGENT_REGEX =
  /Googlebot|Google-InspectionTool|GoogleOther|Mediapartners-Google|AdsBot-Google|Google-PageRenderer|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Twitterbot|Slackbot|facebookexternalhit|Facebot|LinkedInBot|Discordbot|WhatsApp|TelegramBot|KakaoTalk|Applebot/i;

export const isBotUserAgent = (
  userAgent: string | undefined | null,
): boolean => !!userAgent && BOT_USER_AGENT_REGEX.test(userAgent);
